import {
  oloLiveSiteOloPageLoaded,
  restaurantsUouPageFinishedLoading,
  restaurantsUouPageStartedLoading,
  restaurantsOloLiveSiteClickOnFulfillment,
  restaurantsOloLiveSiteDispatchModalOpened,
  oloLiveSiteClickOnItem,
  oloLiveSiteItemModalOpened,
  oloLiveSiteAddDishToCart,
  restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuBar,
  restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuDropdownAndOtherMenusInside,
  restaurantsOloLiveSiteClicksInsideDispatchModal,
  restaurantsOloLiveSiteErrorDisplayedInDispatchModal,
  restaurantsOloLiveSiteDispatchModalClosed,
  oloGenericDebugEvent,
  oloEditorInstallationSteps,
  restaurantsEditorPanelEditAction,
  oloEditorMenuReorder,
  oloEditorOrderPageWasAddedToEditorSrc159Evid561,
  oloEditorOrderPageWasDeletedFromEditorSrc159Evid563,
  oloEditorViewOrderClickSrc159Evid555,
  restaurantsEditorPanelLoad,
  restaurantsOloLiveSiteMenuUnavailableCardDisplayedCollapsedSrc159Evid571,
  oloLiveSiteOperationDurationSrc159Evid578,
} from '@wix/bi-logger-restaurants-data/v2';
import type { SchedulingType, TimeSlot } from '../types/businessTypes';
import { DispatchType } from '../types/businessTypes';
import type { PopulatedMenu } from '../types/menusTypes';
import { context } from '../context/RootContext';
import type { PlatformControllerFlowAPI } from '@wix/yoshi-flow-editor';
import type {
  OloPageLoadedParams,
  OloPageStartedLoadingParams,
  OloPageFinishedLoadingParams,
  LiveSiteClickFulfillmentOrigin,
  OloLiveSiteClickOnFulfillmentParams,
  OloLiveSiteDispatchModalOpenedParams,
  OloLiveSiteClickOnItemParams,
  OloLiveSiteItemModalOpenedParams,
  OloLiveSiteAddDishToCartParams,
  OloLiveSiteClicksOnMenuBarParams,
  LiveSiteClicksOnMenuDropdownAndOptionInsideButtonName,
  OloLiveSiteClicksOnMenuDropdownAndOptionInsideParams,
  OloLiveSiteClicksInsideDispatchModalParams,
  LiveSiteClicksInsideDispatchModalButtonType,
  OloLiveSiteErrorDisplayedInDispatchModalParams,
  LiveSiteDispatchModalClosedTriggerName,
  OloLiveSiteDispatchModalClosedParams,
  OloGenericDebugParams,
  OloEditorInstallationStepsParams,
  OloEditorMenuReorderParams,
  OloLiveSiteMenuStatusCardDisplayedParams,
  LiveSiteMenuStatusCardDisplayedPageName,
} from '@wix/restaurants-bi';
import {
  LivesiteFulfillmentType,
  LivesitePageLoadModeType,
  LivesitePageLoadStatusDisplayedType,
  LivesiteClickFulfillmentStatusDisplayedType,
  LiveSiteDispatchModalOpenedSchedulingType,
  PageName,
  WidgetName,
  Product,
  LiveSiteDispatchModalClosedSelectedRadioButton,
  LiveSiteDispatchModalClosedSchedulingType,
  LiveSiteMenuStatusCardDisplayed,
} from '@wix/restaurants-bi';
import type { Origin } from '@wix/editor-platform-sdk-types';
import { DEFAULT_ADDRESS, PAGE_DATA } from '../appConsts/consts';
import {
  getAmountOfItemsInCart,
  getAmountOfSectionsAndItems,
  getHostingEnvironment,
  getErrorType,
  getSelectedRadioButton,
} from '../utils/biUtils';
import type { VisitorLogger } from '@wix/yoshi-flow-editor/external-types/bi';
import type { ErrorType } from 'root/components/DispatchModal/dispatchModalUtils';
import { dispatchState } from 'root/states/DispatchState';
import type { CartButtonNavigationTarget } from 'root/types/cartButton';

type ItemModalCommonParams = {
  itemId: string;
  itemName?: string;
  menuId?: string;
  num_labels?: number;
  sectionId?: string;
};

type LiveSiteOloPageLoadedParams = {
  refferalInfo?: string;
  isMemberLoggedIn: boolean;
  menus: PopulatedMenu[];
};

type ClickOnFulfillmentParams = {
  origin: LiveSiteClickFulfillmentOrigin;
  dispatchType?: DispatchType;
  isMemberLoggedIn?: boolean;
  menuId?: string;
};

type DispatchModalOpenedParams = {
  schedulingType: SchedulingType;
  isAsapDisplayed?: boolean;
  isPreorderDisplayed?: boolean;
  availableDispatchTypes?: DispatchType[];
  currentFulfillment: DispatchType;
  operationId: string;
  selectedSchedulingRadioButton?: SchedulingType;
  isMemberLoggedIn?: boolean;
  selectedTime?: TimeSlot;
  businessDays?: number;
  operationGroup?: string;
  locationId?: string;
  isDefaultLocation?: boolean;
  source?: 'order_now' | 'menu_item';
};

type ClickOnItemParams = ItemModalCommonParams & {
  minItemPrice: number;
  operationId?: string;
  isMenuItemAvailable?: boolean;
  isItemInStock?: boolean;
  operationGroup?: string;
  locationId?: string;
  isDefaultLocation?: boolean;
};

type ItemModalOpenedParams = ItemModalCommonParams & {
  minItemPrice: number;
  numModifiers?: number;
  numModifiersGroups?: number;
  numPriceVariations?: number;
  isMenuItemAvailable?: boolean;
  isItemInStock?: boolean;
  operationId?: string;
  operationGroup?: string;
  locationId?: string;
  isDefaultLocation?: boolean;
};

type AddDishToCartParams = ItemModalCommonParams & {
  labelsList: string;
  itemPrice: number;
  numSelectedModifiers: number;
  numModifiersGroups?: number;
  numPriceVariations?: number;
  amountOfItems: number;
  priceVariationName?: string;
  isSuccess: boolean;
  selectedModifiersList?: string;
  operationId?: string;
  operationGroup?: string;
  locationId?: string;
  isDefaultLocation?: boolean;
};

type ClicksOnMenuDropdownAndOptionParams = {
  buttonName: LiveSiteClicksOnMenuDropdownAndOptionInsideButtonName;
  currentMenuId?: string;
  currentMenuName?: string;
  currentMenuNumber?: number;
  menuId?: string;
  menuName?: string;
  menuNumber?: number;
  numTotalMenus?: number;
  operationId?: string;
  operationGroup?: string;
  locationId?: string;
  isDefaultLocation?: boolean;
};

type ClicksOnMenuBarParams = {
  currentSectionNumber?: number;
  numTotalSections?: number;
  operationId?: string;
  sectionId?: string;
  sectionName?: string;
  operationGroup?: string;
  locationId?: string;
  isDefaultLocation?: boolean;
};

type ClicksInsideDispatchModalParams = {
  dispatchType: DispatchType;
  isPreorder?: boolean;
  buttonType: LiveSiteClicksInsideDispatchModalButtonType;
  operationId?: string;
  operationGroup?: string;
  locationId?: string;
  isDefaultLocation?: boolean;
};

type ErrorDisplayedInDispatchModalParams = {
  dispatchType: DispatchType;
  errorType: ErrorType;
  errorMessage?: string;
};

type DispatchModalClosedParams = {
  dispatchType: DispatchType;
  triggerName: LiveSiteDispatchModalClosedTriggerName;
  schedulingType: SchedulingType;
  isAsapDisplayed?: boolean;
  isPreorderDisplayed?: boolean;
  availableDispatchTypes?: DispatchType[];
  operationId: string;
  selectedSchedulingRadioButton?: SchedulingType;
  isMemberLoggedIn?: boolean;
  selectedTime?: TimeSlot;
  businessDays?: number;
  changedFields?: string;
  operationGroup?: string;
  locationId?: string;
  isDefaultLocation?: boolean;
};

type GenericDebugEventParams = {
  subjectType?: string;
  value?: object;
};

type EditorInstallationStepsParams = {
  isFirstInstall?: boolean;
  isInstallationRetry?: boolean;
  step: string;
  value?: string;
  isStudio?: boolean;
  appDefId?: string;
  msid?: string;
  errorMessage?: string;
  lightboxId?: string;
  lightboxTitle?: string;
  lightboxWidgetId?: string;
  lightboxLayout?: string;
  lightboxParentRef?: string;
};

type EditorMenuReorderParams = {
  menuId: string;
  menuName: string;
  numMenus: number;
  indexListBeforeChange: string;
  indexListAfterChange: string;
};

type CartButtonClickParams = {
  isMemberLoggedIn: boolean;
  cartState: number;
  navigationTarget: CartButtonNavigationTarget;
  operationGroup?: string;
  locationId?: string;
  isDefaultLocation?: boolean;
};

type PanelEditActionParams = {
  panelName: string;
  value: string;
  widgetId: string;
  widgetName: string;
  pageId: string;
  msid: string;
  firstLevel: string;
  lastLevel?: string;
};

type PanelLoadParams = {
  widgetId: string;
  pageId: string;
  widgetName: string;
  panelName: string;
  origin: string;
  msid: string;
};

type EditorPageAddedParams = {
  operationId?: string;
  isDuplicated: boolean;
  isUpdated: boolean;
};

type EditorPageDeletedParams = {
  operationId?: string;
  isSuccessful: boolean;
};

type MenuStatusCardDisplayedParams = {
  isCardDisplayed?: boolean;
  pageName?: LiveSiteMenuStatusCardDisplayedPageName;
  menuId?: string;
  isButtonDisplayed?: boolean;
  itemId?: string;
  sectionId?: string;
  operationGroup?: string;
  locationId?: string;
  isDefaultLocation?: boolean;
};

export type OperationDurationExtraFields = {
  opsGroupQuantity?: number;
  operationsQuantity?: number;
  menusQuantity?: number;
  sectionsQuantity?: number;
  itemsQuantity?: number;
  variantsQuantity?: number;
  modifiersQuantity?: number;
  modifiersGroupsQuantity?: number;
  labelsQuantity?: number;
  apiRequestId?: string;
  apiErrorMsg?: string;
};

export type BaseOperationDurationParams = {
  eventName?: string;
  duration?: number;
  extraFields?: OperationDurationExtraFields;
};

export type OperationDurationParams = BaseOperationDurationParams & {
  operationId?: string;
  operationName?: string;
  locationId?: string;
  operationGroup?: string;
  isDefaultLocation?: boolean;
  eventName?: string;
  duration?: number;
  useSSRCache?: boolean;
  isSSRCall?: boolean;
  extraFields?: OperationDurationExtraFields;
};

export interface IBIReporterService {
  reportPanelLoaded: (params: PanelLoadParams) => void;
  reportPanelEditAction: (params: PanelEditActionParams) => void;
  reportOloLiveSiteClickOnCartButton: (params: CartButtonClickParams) => void;
  reportOloLiveSiteOloPageLoadedBiEvent: ({
    refferalInfo,
    isMemberLoggedIn,
    menus,
  }: LiveSiteOloPageLoadedParams) => void;
  reportRestaurantsUouPageStartedLoadingBiEvent: () => void;
  reportRestaurantsUouPageFinishedLoadingBiEvent: () => void;
  reportOloLiveSiteClickOnFulfillmentBiEvent: ({
    origin,
    dispatchType,
    isMemberLoggedIn,
    menuId,
  }: ClickOnFulfillmentParams) => void;
  reportOloLiveSiteDispatchModalOpenedBiEvent: ({
    schedulingType,
    isAsapDisplayed,
    availableDispatchTypes,
    isPreorderDisplayed,
    currentFulfillment,
    operationId,
    isMemberLoggedIn,
    selectedSchedulingRadioButton,
    selectedTime,
    businessDays,
    operationGroup,
    locationId,
    isDefaultLocation,
  }: DispatchModalOpenedParams) => void;
  reportOloLiveSiteClickOnItemBiEvent: ({
    itemId,
    itemName,
    menuId,
    sectionId,
    minItemPrice,
    isMenuItemAvailable,
    operationGroup,
    locationId,
    isDefaultLocation,
  }: ClickOnItemParams) => void;
  reportOloLiveSiteItemModalOpenedBiEvent: ({
    itemId,
    itemName,
    menuId,
    sectionId,
    minItemPrice,
    num_labels,
    numModifiers,
    numModifiersGroups,
    numPriceVariations,
    operationId,
    locationId,
    operationGroup,
    isDefaultLocation,
  }: ItemModalOpenedParams) => void;
  reportOloLiveSiteAddDishToCartBiEvent: ({
    itemId,
    itemName,
    menuId,
    sectionId,
    num_labels,
    numSelectedModifiers,
    priceVariationName,
    selectedModifiersList,
    amountOfItems,
    itemPrice,
    isSuccess,
    labelsList,
    operationId,
    locationId,
    operationGroup,
    isDefaultLocation,
  }: AddDishToCartParams) => void;
  reportOloLiveSiteClicksOnMenuDropdownAndOptionBiEvent: ({
    buttonName,
    currentMenuId,
    currentMenuName,
    currentMenuNumber,
    operationId,
    numTotalMenus,
    menuNumber,
    menuName,
    menuId,
    locationId,
    operationGroup,
    isDefaultLocation,
  }: ClicksOnMenuDropdownAndOptionParams) => void;
  reportOloLiveSiteClicksOnMenuBarBiEvent: ({
    currentSectionNumber,
    numTotalSections,
    operationId,
    sectionId,
    sectionName,
    locationId,
    operationGroup,
    isDefaultLocation,
  }: ClicksOnMenuBarParams) => void;
  reportOloLiveSiteClicksInsideDispatchModalBiEvent: ({
    dispatchType,
    isPreorder,
    buttonType,
    operationId,
    locationId,
    operationGroup,
    isDefaultLocation,
  }: ClicksInsideDispatchModalParams) => void;
  reportOloLiveSiteErrorDisplayedInDispatchModalBiEvent: ({
    dispatchType,
    errorType,
    errorMessage,
  }: ErrorDisplayedInDispatchModalParams) => void;
  reportOloLiveSiteDispatchModalClosedBiEvent: ({
    dispatchType,
    triggerName,
    operationId,
    selectedSchedulingRadioButton,
    isAsapDisplayed,
    isPreorderDisplayed,
    schedulingType,
    availableDispatchTypes,
    isMemberLoggedIn,
    selectedTime,
    businessDays,
    changedFields,
    locationId,
    operationGroup,
    isDefaultLocation,
  }: DispatchModalClosedParams) => void;
  reportOloGenericDebugBiEvent: ({ subjectType, value }: GenericDebugEventParams) => void;
  reportOloEditorInstallationStepsEvent: ({ step }: EditorInstallationStepsParams) => void;
  reportOloEditorMenuReorderBiEvent: ({
    menuId,
    menuName,
    numMenus,
    indexListBeforeChange,
    indexListAfterChange,
  }: EditorMenuReorderParams) => void;
  reportOloEditorPageAddedBiEvent: ({
    operationId,
    isDuplicated,
    isUpdated,
  }: EditorPageAddedParams) => void;

  reportOloEditorPageDeletedBiEvent: ({
    operationId,
    isSuccessful,
  }: EditorPageDeletedParams) => void;
  reportOloMenuStatusCardDisplayedBiEvent: ({
    itemId,
    sectionId,
    menuId,
    isButtonDisplayed,
    pageName,
    isCardDisplayed,
    locationId,
    operationGroup,
    isDefaultLocation,
  }: MenuStatusCardDisplayedParams) => void;

  reportOperationDurationBiEvent: ({
    operationId,
    operationName,
    locationId,
    operationGroup,
    isDefaultLocation,
    eventName,
    duration,
    useSSRCache,
    isSSRCall,
    extraFields,
  }: OperationDurationParams) => void;
}

export const BIReporterService = ({
  biLogger,
  environment,
  origin,
  resolution,
  widgetInstanceId = '',
}: {
  biLogger?: VisitorLogger | null;
  environment: PlatformControllerFlowAPI['environment'];
  origin?: Origin;
  resolution?: {
    width: number;
    height: number;
  };
  widgetInstanceId?: string;
}): IBIReporterService => {
  const biReporterObject = {
    reportPanelLoaded: (params: PanelLoadParams) => {
      biLogger?.report(
        restaurantsEditorPanelLoad({
          widgetInstanceId,
          product: Product.OLO,
          ...params,
        })
      );
    },
    reportPanelEditAction: (params: PanelEditActionParams) => {
      const { widgetId, widgetName, panelName, firstLevel, lastLevel, value, pageId, msid } =
        params;
      biLogger?.report(
        restaurantsEditorPanelEditAction({
          widgetId,
          widgetName,
          firstLevel,
          lastLevel: lastLevel ?? firstLevel,
          panelName,
          value,
          msid,
          widgetInstanceId,
          pageId,
          product: Product.OLO,
        })
      );
    },
    reportOloLiveSiteClickOnCartButton: (params: CartButtonClickParams) => {
      const {
        cartState,
        isMemberLoggedIn,
        navigationTarget,
        operationGroup,
        locationId,
        isDefaultLocation,
      } = params;
      biLogger?.report(
        oloEditorViewOrderClickSrc159Evid555({
          cartState,
          isMemberLoggedIn,
          mode: environment.isPreview ? 'preview' : 'live_site',
          navigationTarget,
          operationGroup,
          locationId,
          isDefaultLocation,
        })
      );
    },
    reportOloLiveSiteOloPageLoadedBiEvent: ({
      isMemberLoggedIn,
      menus,
      refferalInfo,
    }: LiveSiteOloPageLoadedParams) => {
      const { isPreview } = environment;
      const { numOfItems, numOfSections } = getAmountOfSectionsAndItems(menus);
      const isDelivery = dispatchState.selectedDispatchType === DispatchType.DELIVERY;
      const { operationGroupId, locationId, locationDetails } =
        dispatchState.currentOperation ?? {};

      const eventParams: OloPageLoadedParams = {
        cartState: getAmountOfItemsInCart(),
        defaultSelectedFulfillment: LivesiteFulfillmentType[dispatchState.selectedDispatchType],
        defaultSelectedTimeSlot: context.initialTimeSlotText,
        deliveryFee:
          typeof dispatchState.dispatchInfo.selectedTimeSlot?.fulfillmentDetails.fee !== 'undefined'
            ? Number(dispatchState.dispatchInfo.selectedTimeSlot?.fulfillmentDetails.fee)
            : undefined,
        isDeliveryAvailable: dispatchState.isDispatchAvailable(DispatchType.DELIVERY),
        isDeliveryConfig: dispatchState.isDispatchConfigured(DispatchType.DELIVERY),
        isDeafultAddress: !isDelivery
          ? dispatchState.dispatchesInfo[DispatchType.PICKUP]?.address?.formattedAddress ===
            DEFAULT_ADDRESS
          : undefined,
        isMemberLoggedIn,
        minOrderDisplayed:
          dispatchState.dispatchInfo?.selectedTimeSlot?.fulfillmentDetails.minOrderPrice?.toString(),
        isPickupAvailable: dispatchState.isDispatchAvailable(DispatchType.PICKUP),
        isPickupConfig: dispatchState.isDispatchConfigured(DispatchType.PICKUP),
        mode: isPreview ? LivesitePageLoadModeType.PREVIEW : LivesitePageLoadModeType.LIVE_SITE,
        numDishes: numOfItems,
        numMenus: menus?.length,
        numSections: numOfSections,
        operationId: dispatchState.currentOperationId,
        statusDisplayed: dispatchState.hasAvailableDispatches
          ? LivesitePageLoadStatusDisplayedType.ACCEPTING_ORDERS
          : LivesitePageLoadStatusDisplayedType.CLOSED,
        refferalInfo,
        operationGroup: operationGroupId,
        locationId,
        isDefaultLocation: locationDetails?.default,
      };
      biLogger?.report(oloLiveSiteOloPageLoaded(eventParams));
    },
    reportRestaurantsUouPageStartedLoadingBiEvent: () => {
      const eventParams: OloPageStartedLoadingParams = {
        hosting: getHostingEnvironment(environment, origin?.subType),
        pageName: PageName.ONLINE_ORDERING,
        product: Product.OLO,
        widgetId: PAGE_DATA.widgetId,
        widgetInstanceId,
        widgetName: WidgetName.OLO,
      };
      biLogger?.report(restaurantsUouPageStartedLoading(eventParams));
    },
    reportRestaurantsUouPageFinishedLoadingBiEvent: () => {
      const eventParams: OloPageFinishedLoadingParams = {
        hosting: getHostingEnvironment(environment, origin?.subType),
        pageName: PageName.ONLINE_ORDERING,
        product: Product.OLO,
        widgetId: PAGE_DATA.widgetId,
        widgetInstanceId,
        widgetName: WidgetName.OLO,
      };
      biLogger?.report(restaurantsUouPageFinishedLoading(eventParams));
    },
    reportOloLiveSiteClickOnFulfillmentBiEvent: ({
      // eslint-disable-next-line @typescript-eslint/no-shadow
      origin,
      dispatchType,
      isMemberLoggedIn,
      menuId,
    }: ClickOnFulfillmentParams) => {
      const eventParams: OloLiveSiteClickOnFulfillmentParams = {
        cartState: getAmountOfItemsInCart(),
        isMemberLoggedIn,
        operationId: dispatchState.currentOperationId,
        selectedFulfillment: dispatchType && LivesiteFulfillmentType[dispatchType],
        currentFulfillment: LivesiteFulfillmentType[dispatchState.selectedDispatchType],
        origin,
        statusDisplayed: dispatchState.hasAvailableDispatches
          ? LivesiteClickFulfillmentStatusDisplayedType.ACCEPTING_ORDERS
          : LivesiteClickFulfillmentStatusDisplayedType.CLOSED,
        menuId,
        operationGroup: dispatchState.currentOperation?.operationGroupId,
        locationId: dispatchState.currentOperation?.locationId,
        isDefaultLocation: dispatchState.currentOperation?.locationDetails?.default,
      };

      biLogger?.report(restaurantsOloLiveSiteClickOnFulfillment(eventParams));
    },
    reportOloLiveSiteDispatchModalOpenedBiEvent: ({
      schedulingType,
      isAsapDisplayed,
      availableDispatchTypes = [],
      isPreorderDisplayed,
      currentFulfillment,
      operationId,
      isMemberLoggedIn,
      selectedSchedulingRadioButton,
      selectedTime,
      businessDays,
      operationGroup,
      locationId,
      isDefaultLocation,
      source,
    }: DispatchModalOpenedParams) => {
      const eventParams: OloLiveSiteDispatchModalOpenedParams = {
        operationId,
        schedulingType: LiveSiteDispatchModalOpenedSchedulingType[schedulingType],
        currentFulfillment: LivesiteFulfillmentType[currentFulfillment],
        isAsapDisplayed,
        isPreorderDisplayed,
        isDeliveryDisplayed: availableDispatchTypes.includes(DispatchType.DELIVERY),
        isPickupDisplayed: availableDispatchTypes.includes(DispatchType.PICKUP),
        isMemberLoggedIn,
        selectedRadioButton: getSelectedRadioButton(selectedSchedulingRadioButton),
        fromDateAndTime: selectedTime?.startTime?.valueOf(),
        untilDateAndTime: selectedTime?.endTime?.valueOf(),
        businessDays,
        operationGroup,
        locationId,
        isDefaultLocation,
        source,
      };

      biLogger?.report(restaurantsOloLiveSiteDispatchModalOpened(eventParams));
    },
    reportOloLiveSiteClickOnItemBiEvent: ({
      itemId,
      itemName = '',
      menuId,
      sectionId,
      minItemPrice,
      operationId,
      isMenuItemAvailable,
      isItemInStock,
      operationGroup,
      locationId,
      isDefaultLocation,
    }: ClickOnItemParams) => {
      const eventParams: OloLiveSiteClickOnItemParams = {
        itemId,
        itemName,
        menuId,
        sectionId,
        minItemPrice,
        operationId,
        isMenuItemAvailable,
        isItemInStock,
        operationGroup,
        locationId,
        isDefaultLocation,
      };

      biLogger?.report(oloLiveSiteClickOnItem(eventParams));
    },
    reportOloLiveSiteItemModalOpenedBiEvent: ({
      itemId,
      itemName = '',
      menuId = '',
      sectionId = '',
      minItemPrice,
      num_labels,
      numModifiers = 0,
      numModifiersGroups = 0,
      numPriceVariations = 0,
      isMenuItemAvailable,
      isItemInStock,
      operationId,
      locationId,
      operationGroup,
      isDefaultLocation,
    }: ItemModalOpenedParams) => {
      const eventParams: OloLiveSiteItemModalOpenedParams = {
        itemId,
        itemName,
        menuId,
        sectionId,
        minItemPrice,
        num_labels,
        numModifiers,
        numModifiersGroups,
        numPriceVariations,
        isMenuItemAvailable,
        isItemInStock,
        operationId,
        locationId,
        operationGroup,
        isDefaultLocation,
      };

      biLogger?.report(oloLiveSiteItemModalOpened(eventParams));
    },
    reportOloLiveSiteAddDishToCartBiEvent: ({
      itemId,
      itemName,
      menuId,
      sectionId,
      num_labels,
      numSelectedModifiers,
      priceVariationName,
      selectedModifiersList,
      amountOfItems,
      itemPrice,
      isSuccess,
      labelsList,
      operationId,
      locationId,
      operationGroup,
      isDefaultLocation,
    }: AddDishToCartParams) => {
      const eventParams: OloLiveSiteAddDishToCartParams = {
        itemId,
        itemName,
        menuId,
        sectionId,
        num_labels,
        numSelectedModifiers,
        priceVariationName,
        selectedModifiersList,
        amountOfItems,
        priceOfItem: itemPrice.toString(),
        isSuccess,
        labelsList,
        operationId,
        locationId,
        operaionGroup: operationGroup,
        isDefaultLocation,
      };

      biLogger?.report(oloLiveSiteAddDishToCart(eventParams));
    },
    reportOloLiveSiteClicksOnMenuDropdownAndOptionBiEvent: ({
      buttonName,
      currentMenuId,
      currentMenuName,
      currentMenuNumber,
      operationId = '',
      numTotalMenus,
      menuNumber,
      menuName,
      menuId,
      locationId,
      operationGroup,
      isDefaultLocation,
    }: ClicksOnMenuDropdownAndOptionParams) => {
      const eventParams: OloLiveSiteClicksOnMenuDropdownAndOptionInsideParams = {
        buttonName,
        currentMenuId,
        currentMenuName,
        currentMenuNumber,
        operationId,
        menuNumber,
        menuName,
        menuId,
        numTotalMenus,
        locationId,
        operationGroup,
        isDefaultLocation,
      };

      biLogger?.report(
        restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuDropdownAndOtherMenusInside(eventParams)
      );
    },
    reportOloLiveSiteClicksOnMenuBarBiEvent: ({
      currentSectionNumber,
      numTotalSections,
      operationId = '',
      sectionId,
      sectionName,
      operationGroup,
      locationId,
      isDefaultLocation,
    }: ClicksOnMenuBarParams) => {
      const eventParams: OloLiveSiteClicksOnMenuBarParams = {
        currentSectionNumber,
        numTotalSections,
        operationId,
        sectionId,
        sectionName,
        operationGroup,
        locationId,
        isDefaultLocation,
      };

      biLogger?.report(restaurantsOloLiveSiteOnlineOrdersPageClicksOnMenuBar(eventParams));
    },
    reportOloLiveSiteClicksInsideDispatchModalBiEvent: ({
      dispatchType,
      isPreorder,
      buttonType,
      operationId,
      operationGroup,
      locationId,
      isDefaultLocation,
    }: ClicksInsideDispatchModalParams) => {
      const eventParams: OloLiveSiteClicksInsideDispatchModalParams = {
        currentFulfillment: LivesiteFulfillmentType[dispatchType],
        isPreorder,
        buttonType,
        operationId,
        operationGroup,
        locationId,
        isDefaultLocation,
      };

      biLogger?.report(restaurantsOloLiveSiteClicksInsideDispatchModal(eventParams));
    },
    reportOloLiveSiteErrorDisplayedInDispatchModalBiEvent: ({
      dispatchType,
      errorType,
      errorMessage = '',
    }: ErrorDisplayedInDispatchModalParams) => {
      const eventParams: OloLiveSiteErrorDisplayedInDispatchModalParams = {
        currentFulfillment: LivesiteFulfillmentType[dispatchType],
        errorType: getErrorType(errorType),
        errorMessage,
        operationGroup: dispatchState.currentOperation?.operationGroupId,
        locationId: dispatchState.currentOperation?.locationId,
        isDefaultLocation: dispatchState.currentOperation?.locationDetails?.default,
      };

      biLogger?.report(restaurantsOloLiveSiteErrorDisplayedInDispatchModal(eventParams));
    },

    reportOloLiveSiteDispatchModalClosedBiEvent: ({
      dispatchType,
      triggerName,
      operationId,
      selectedSchedulingRadioButton,
      isAsapDisplayed,
      isPreorderDisplayed,
      schedulingType,
      availableDispatchTypes = [],
      isMemberLoggedIn,
      selectedTime,
      businessDays,
      changedFields,
      locationId,
      operationGroup,
      isDefaultLocation,
    }: DispatchModalClosedParams) => {
      const selectedRadioButton =
        selectedSchedulingRadioButton && getSelectedRadioButton(selectedSchedulingRadioButton);
      const eventParams: OloLiveSiteDispatchModalClosedParams = {
        currentFulfillment: LivesiteFulfillmentType[dispatchType],
        triggerName,
        operationId,
        schedulingType: LiveSiteDispatchModalClosedSchedulingType[schedulingType],
        selectedRadioButton: selectedRadioButton
          ? LiveSiteDispatchModalClosedSelectedRadioButton[selectedRadioButton]
          : undefined,

        isAsapDisplayed,
        isPreorderDisplayed,
        isDeliveryDisplayed: availableDispatchTypes.includes(DispatchType.DELIVERY),
        isPickupDisplayed: availableDispatchTypes.includes(DispatchType.PICKUP),
        isMemberLoggedIn,
        fromDateAndTime: selectedTime?.startTime?.valueOf(),
        untilDateAndTime: selectedTime?.endTime?.valueOf(),
        businessDays,
        changedFields,
        locationId,
        operationGroup,
        isDefaultLocation,
      };

      biLogger?.report(restaurantsOloLiveSiteDispatchModalClosed(eventParams));
    },
    reportOloGenericDebugBiEvent: ({ subjectType, value }: GenericDebugEventParams) => {
      const data = { ...value, resolution };
      const eventParams: OloGenericDebugParams = {
        subjectType,
        hosting: getHostingEnvironment(environment, origin?.subType),
        value: JSON.stringify(data),
      };
      biLogger?.report(oloGenericDebugEvent(eventParams));
    },
    reportOloEditorInstallationStepsEvent: ({
      step,
      value,
      isFirstInstall,
      isInstallationRetry,
      isStudio,
      appDefId,
      msid,
      errorMessage,
      lightboxId,
      lightboxTitle,
      lightboxWidgetId,
      lightboxLayout,
      lightboxParentRef,
    }: EditorInstallationStepsParams) => {
      const eventParams: OloEditorInstallationStepsParams = {
        origin: JSON.stringify(origin),
        step,
        value,
        isFirstInstall,
        isInstallationRetry,
        isStudio,
        appDefId,
        msid,
        errorMessage,
        lightboxId,
        lightboxTitle,
        lightboxWidgetId,
        lightboxLayout,
        lightboxParentRef,
      };
      biLogger?.report(oloEditorInstallationSteps(eventParams));
    },
    reportOloEditorMenuReorderBiEvent: ({
      menuId,
      menuName,
      numMenus,
      indexListBeforeChange,
      indexListAfterChange,
    }: EditorMenuReorderParams) => {
      const eventParams: OloEditorMenuReorderParams = {
        menuId,
        menuName,
        numMenus,
        indexListBeforeChange,
        indexListAfterChange,
      };

      biLogger?.report(oloEditorMenuReorder(eventParams));
    },
    reportOloEditorPageAddedBiEvent: ({
      operationId,
      isDuplicated,
      isUpdated,
    }: EditorPageAddedParams) => {
      const eventParams = {
        operationId,
        isDuplicated,
        isUpdated,
      };

      biLogger?.report(oloEditorOrderPageWasAddedToEditorSrc159Evid561(eventParams));
    },
    reportOloEditorPageDeletedBiEvent: ({ operationId, isSuccessful }: EditorPageDeletedParams) => {
      const eventParams = {
        operationId,
        is_successful: isSuccessful,
      };

      biLogger?.report(oloEditorOrderPageWasDeletedFromEditorSrc159Evid563(eventParams));
    },
    reportOloMenuStatusCardDisplayedBiEvent: ({
      itemId,
      sectionId,
      menuId,
      isButtonDisplayed,
      pageName,
      isCardDisplayed,
      locationId,
      operationGroup,
      isDefaultLocation,
    }: MenuStatusCardDisplayedParams) => {
      const eventParams: OloLiveSiteMenuStatusCardDisplayedParams = {
        operationId: dispatchState.currentOperationId,
        mode: environment.isPreview ? 'preview' : 'live_site',
        itemId,
        sectionId,
        menuId,
        isButtonDisplayed: `${isButtonDisplayed}`,
        pageName,
        cardDisplayed: isCardDisplayed
          ? LiveSiteMenuStatusCardDisplayed.DISPLAYED
          : LiveSiteMenuStatusCardDisplayed.COLLAPSED,
        locationId,
        operationGroup,
        isDefaultLocation,
      };

      biLogger?.report(
        restaurantsOloLiveSiteMenuUnavailableCardDisplayedCollapsedSrc159Evid571(eventParams)
      );
    },

    reportOperationDurationBiEvent: ({
      locationId,
      operationGroup,
      isDefaultLocation,
      eventName,
      duration,
      useSSRCache,
      isSSRCall,
      extraFields,
    }: OperationDurationParams) => {
      const eventParams = {
        appName: 'OLO',
        eventName,
        operationId: dispatchState.currentOperationId,
        locationId,
        operationGroup,
        isDefaultLocation,
        duration,
        SSRCache: useSSRCache,
        isSSRCall,
        extendedFields: JSON.stringify(extraFields),
      };

      biLogger?.report(oloLiveSiteOperationDurationSrc159Evid578(eventParams));
    },
  };

  return biReporterObject;
};
